import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

function MeiosEntradaFormPage() {
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Meio de Entrada' : 'Novo Meio de Entrada';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar um novo meio de entrada';

  // Busca os dados do meio de entrada para edição
  useEffect(() => {
    if (id) {
      setLoading(true);
      api.get(`/meios-entrada/${id}`)
        .then(response => {
          const { nome } = response.data.data;
          setNome(nome);
        })
        .catch(err => {
          setError('Não foi possível carregar os dados do meio de entrada.');
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  // Envia os dados do formulário (criação ou atualização)
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const meioEntradaData = { nome };

    try {
      if (id) {
        await api.put(`/meios-entrada/${id}`, meioEntradaData);
      } else {
        await api.post('/meios-entrada', meioEntradaData);
      }
      navigate('/painel/meios-entrada');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar o meio de entrada. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <div className="meios-entrada-form-page">
        <p>Carregando dados do meio de entrada...</p>
      </div>
    );
  }

  return (
    <div className="meios-entrada-form-page">
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card meios-entrada-form-card">
        <div className="card-body">
          <form className="meios-entrada-form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mb-3">
              <label htmlFor="nome" className="form-label">Nome</label>
              <input
                type="text"
                className="form-control"
                id="nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="meios-entrada-form-actions d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/meios-entrada')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MeiosEntradaFormPage;
